import { AuditLog, AuditLogList } from "@wingspanhq/wingspan-api-sdk";
import orderBy from "lodash/orderBy";

/**
 * One newest-first timeline from the per-resource audit-log pages that
 * `useQueryAuditLogsForResources` fans out.
 *
 * Slicing the merge to `pageSize` is exact rather than an approximation: the
 * globally newest `pageSize` entries are necessarily a subset of the union of
 * each resource's own newest `pageSize`, so no entry that belongs on the page
 * can be missing from the input.
 */
export const selectorMergedAuditLogs = ({
  lists,
  pageSize
}: {
  lists: AuditLogList[];
  pageSize: number;
}): AuditLog[] =>
  orderBy(
    lists.flatMap(list => list.data),
    log => log.timestamp.getTime(),
    "desc"
  ).slice(0, pageSize);
